import { Navigate, useLocation } from 'react-router-dom'
import { buildLegacyAnalysisTarget, type AnalysisTab } from './analysisTabs'

export interface LegacyAnalysisRedirectProps {
  /** Aba em que a URL antiga aterrissa na secao unificada. */
  tab: AnalysisTab
}

/**
 * Redirect das duas URLs antigas para /app/analise-estatistica (r6-29, R1).
 *
 * Existe em vez de um `<Navigate to="/app/analise-estatistica" replace />` direto porque
 * a forma em string DESCARTA a query: o aluno com bookmark de
 * `/app/analise-progresso?period=12w&status=nao_estudado&specialty=CLM&q=hiv` cairia na
 * tela crua, sem nada em build, lint ou tsc acusando. O destino e o objeto
 * `{ pathname, search }` que `buildLegacyAnalysisTarget` monta.
 *
 * `replace` de proposito: o redirect nao entra no historico, entao "voltar" leva o aluno
 * para onde ele estava antes, e nao de volta para a URL antiga num laco.
 */
export function LegacyAnalysisRedirect({ tab }: LegacyAnalysisRedirectProps) {
  const location = useLocation()

  return <Navigate to={buildLegacyAnalysisTarget(location.search, tab)} replace />
}
